import { useRouterState } from '@tanstack/react-router'
import type { JSX } from 'react'

import { LoadingBar } from '@/components/ui/loading-bar'

export function NavigationProgress(): JSX.Element {
  const isLoading = useRouterState({ select: (s) => s.status === 'pending' })

  return <LoadingBar active={isLoading} className="fixed top-0 left-0 z-[100] h-[5px]" />
}
